import {DurableFunctionInstanceStatus} from "./DurableFunctionInstance";
import moment from 'moment';

export class WorkloadInstanceQuery {

    public static fromQueryString(queryString: string) {

        const workloadInstanceQuery = new WorkloadInstanceQuery();
        if(queryString.indexOf("?") === 0)
        {
            queryString = queryString.slice(1);
        }
        
        return queryString.split("&").reduce((acc: WorkloadInstanceQuery,queryKeyVal: string) => {
            
            const parts = queryKeyVal.split("=");
            const key = parts[0];
            let val: any = parts[1];
            
            if(key.toLowerCase().indexOf("date") !== -1)
            {
                acc[key] = moment(decodeURIComponent(val)).toDate();
                return acc;
            }
            
            if(key.toLowerCase() === "status")
            {
                acc.status.push(val);
                return acc;
            }
            
            acc[key] = val;
            
            return acc;
            
        },workloadInstanceQuery);
        
    }
    
    public static copyOf(other: WorkloadInstanceQuery): WorkloadInstanceQuery {
        const newInstanceQuery = new WorkloadInstanceQuery();
        return Object.assign(newInstanceQuery,other);
    }
    
    public static withDefaults(): WorkloadInstanceQuery {

        const newInstanceQuery = new WorkloadInstanceQuery();

        newInstanceQuery.toDate = moment().add(1,'days').toDate();
        newInstanceQuery.toDate.setHours(0,0,0,0);
        
        var fromDate = new Date();
        fromDate.setHours(0, 0, 0, 0);
        newInstanceQuery.fromDate = fromDate;

        newInstanceQuery.status = ["Running","Completed","Failed","Terminated","Pending"];
     
        return newInstanceQuery
    }
    
    public static withDefaultsForSchool(tenantId:string, schoolCode: string): WorkloadInstanceQuery {
        
        const query = WorkloadInstanceQuery.withDefaults();
        
        query.tenantId = tenantId.toLowerCase();
        query.schoolCode = schoolCode.toLowerCase();
        
        return query;
    }
    
    [key: string]: any;
    
    tenantId?: string;
    schoolCode?: string;
    toDate?: Date;
    fromDate?: Date;
    status: DurableFunctionInstanceStatus[];
    workloadName?: string;
    playlistName?: string;
    isBulkWorkload?: boolean;
    
    private constructor() {
        this.status = [];
    }
    
    
}